import { X, Save, Eye, Loader2 } from "lucide-react";
import CompaniesSection   from "./CompaniesSection";
import DepartmentsSection from "./DepartmentsSection";
import UsersSection       from "./UsersSection";

const VisibilityModal = ({
  t, styles, theme,
  allCompanies, loading, visibilityHook,
  onClose, onSave,
}) => {
  const {
    selectedCompanies, departmentsByCompany, selectedDepartments,
    usersByCompany, selectedUsers, search, setSearch,
    toggleCompany, toggleSelectAllCompanies,
    toggleDepartment, toggleSelectAllDepartments, toggleSelectAllDepartmentsGlobal,
    toggleUser, toggleSelectAllDepartmentUsers, toggleSelectAllCompanyUsers, toggleSelectAllUsersGlobal,
  } = visibilityHook;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(4px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        backgroundColor: theme === "dark" ? "#0f172a" : "#ffffff",
        borderRadius: "16px",
        boxShadow: theme === "dark" ? "0 25px 50px rgba(0,0,0,0.6)" : "0 25px 50px rgba(0,0,0,0.12)",
        maxWidth: "720px",
        width: "90%",
        maxHeight: "90vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        animation: "slideUp 0.3s ease-out"
      }} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={{
          padding: "28px",
          borderBottom: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
          background: theme === "dark" 
            ? "linear-gradient(135deg, rgba(15,23,42,0.8) 0%, rgba(30,41,59,0.5) 100%)"
            : "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.8) 100%)"
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <h2 style={{
                fontSize: "22px",
                fontWeight: "700",
                color: theme === "dark" ? "#f1f5f9" : "#0f172a",
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "12px"
              }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "10px",
                  background: "linear-gradient(135deg, #2E7CBA 0%, #1e5a8a 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(46, 124, 186, 0.3)"
                }}>
                  <Eye size={22} style={{ color: "#ffffff" }} />
                </div>
                {t.visibilityControlTitle}
              </h2>
              <p style={{
                fontSize: "13px",
                color: theme === "dark" ? "rgba(226,232,240,0.7)" : "rgba(15,23,42,0.6)",
                margin: "8px 0 0 52px"
              }}>
                {t.visibilityDesc}
              </p>
            </div>
            <button
              onClick={onClose}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: theme === "dark" ? "rgba(226,232,240,0.5)" : "rgba(15,23,42,0.5)",
                transition: "all 0.2s ease",
                padding: "4px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = theme === "dark" ? "#f1f5f9" : "#0f172a";
                e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = theme === "dark" ? "rgba(226,232,240,0.5)" : "rgba(15,23,42,0.5)";
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Search */}
        <div style={{
          padding: "20px 28px",
          borderBottom: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`,
          background: theme === "dark" ? "rgba(15,23,42,0.5)" : "rgba(248,250,252,0.7)"
        }}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t.searchUsers}
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: "8px",
              border: `2px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
              backgroundColor: theme === "dark" ? "rgba(15,23,42,0.8)" : "#ffffff",
              color: theme === "dark" ? "#f1f5f9" : "#0f172a",
              fontSize: "14px",
              fontFamily: "inherit",
              transition: "all 0.3s ease",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = "#2E7CBA";
              e.currentTarget.style.boxShadow = "0 0 0 3px rgba(46, 124, 186, 0.1)";
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)";
              e.currentTarget.style.boxShadow = "none";
            }}
          />
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          overflowY: "auto",
          padding: "28px",
          background: theme === "dark" ? "#0f172a" : "#ffffff",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          WebkitOverflowScrolling: "touch"
        }}>
          {loading ? (
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
              flexDirection: "column",
              gap: "16px",
              color: theme === "dark" ? "rgba(226,232,240,0.6)" : "rgba(15,23,42,0.6)"
            }}>
              <Loader2 size={40} style={{ animation: "spin 1s linear infinite" }} />
              <p style={{ fontSize: "14px", margin: 0 }}>{t.loadingVisibility}</p>
            </div>
          ) : (
            <div style={{ display: "grid", gap: "24px" }}>
              <CompaniesSection
                t={t} styles={styles} theme={theme}
                allCompanies={allCompanies}
                selectedCompanies={selectedCompanies}
                onToggle={toggleCompany}
                onToggleAll={() => toggleSelectAllCompanies(allCompanies)}
              />
              {selectedCompanies.length > 0 && (
                <>
                  <DepartmentsSection
                    t={t} styles={styles} theme={theme}
                    selectedCompanies={selectedCompanies}
                    departmentsByCompany={departmentsByCompany}
                    selectedDepartments={selectedDepartments}
                    onToggle={toggleDepartment}
                    onToggleAll={toggleSelectAllDepartments}
                    onToggleAllGlobal={toggleSelectAllDepartmentsGlobal}
                  />
                  <UsersSection
                    t={t} styles={styles} theme={theme}
                    selectedCompanies={selectedCompanies}
                    usersByCompany={usersByCompany}
                    selectedUsers={selectedUsers}
                    search={search}
                    onToggleUser={toggleUser}
                    onToggleAllCompanyUsers={toggleSelectAllCompanyUsers}
                    onToggleAllGlobal={toggleSelectAllUsersGlobal}
                  />
                </>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          padding: "20px 28px",
          borderTop: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
          background: theme === "dark" ? "rgba(15,23,42,0.5)" : "rgba(248,250,252,0.5)",
          display: "flex",
          justifyContent: "flex-end",
          gap: "12px"
        }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 22px",
              borderRadius: "8px",
              border: `1px solid ${theme === "dark" ? "rgba(226,232,240,0.2)" : "rgba(15,23,42,0.2)"}`,
              backgroundColor: theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)",
              color: theme === "dark" ? "#e2e8f0" : "#0f172a",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
              fontSize: "14px",
              fontFamily: "inherit"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.12)" : "rgba(15,23,42,0.08)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)";
            }}
          >
            {t.cancel}
          </button>
          <button
            onClick={onSave}
            disabled={loading || selectedCompanies.length === 0}
            style={{
              padding: "10px 22px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#2E7CBA",
              color: "#ffffff",
              fontWeight: "600",
              cursor: loading || selectedCompanies.length === 0 ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              fontSize: "14px",
              fontFamily: "inherit",
              opacity: loading || selectedCompanies.length === 0 ? 0.6 : 1,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 4px 12px rgba(46, 124, 186, 0.3)"
            }}
            onMouseEnter={(e) => {
              if (!(loading || selectedCompanies.length === 0)) {
                e.currentTarget.style.backgroundColor = "#1e5a8a";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(46, 124, 186, 0.4)";
              }
            }}
            onMouseLeave={(e) => {
              if (!(loading || selectedCompanies.length === 0)) {
                e.currentTarget.style.backgroundColor = "#2E7CBA";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(46, 124, 186, 0.3)";
              }
            }}
          >
            {loading && <Loader2 size={16} style={{ animation: "spin 1s linear infinite" }} />}
            <Save size={16} /> {t.save}
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default VisibilityModal;